module.exports = __webpack_public_path__ + "4669aa8537309e7797bb3dd33eea362e.png";